import { getConfigurationAndCache } from "../common/windowFunctions";
export class DialogManagerClientController {
    constructor(glue, distributedStoreClient) {
        this.glue = glue;
        this.distributedStoreClient = distributedStoreClient;
        this.initialized = false;
        this.userInputTimeout = null;
        this.DialogStore = null;
        this.isDialog = false;
        this.RESPONDER_CHANNEL = null;
        this.openerMessage = null;
        this.spawnData = {};
    }
    async checkIfWindowIsDialog(cb) {
        this.isDialog = false;
        const config = await getConfigurationAndCache(this.glue.windows.my()) ?? {};
        this.isDialog = config?.customProperties?.component?.foreign?.clients?.dialogManager?.isDialog ?? false;
        cb?.(null);
    }
    async registerWithStore(cb) {
        if (this.isDialog) {
            const w = this.glue.windows.my();
            if (!w) {
                console.error("Attempt to register an incompatible window type as a dialog.");
                cb?.();
                return;
            }
            this.RESPONDER_CHANNEL = `Dialog.${w.id}.Show`;
            await this.DialogStore?.set(["dialogs", "available", w.id], { windowName: w.id, componentType: w.application?.name });
        }
        cb?.();
    }
    async initializeOnce() {
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        await this.checkIfWindowIsDialog();
        await this.createStore();
        await this.registerWithStore();
    }
    async createStore() {
        const defaults = {
            dialogs: {
                opened: {},
                available: {},
            },
        };
        const { err, data } = await this.distributedStoreClient.createStore({
            store: "DialogStore",
            values: defaults,
            global: true,
        });
        if (err || !data) {
            console.error("DialogManagerClient could not create store \"DialogStore\"", err);
        }
        else {
            this.DialogStore = data;
        }
    }
    async getAvailableDialog(type, cb) {
        if (!this.DialogStore) {
            const error = "DialogMangerClient.getAvailableDialogs() store not yet initialized}";
            console.error(error);
            cb?.(null);
            return null;
        }
        const { err, data: availableDialogs } = await this.DialogStore.getGlobalValue("dialogs.available");
        if (err) {
            const error = `DialogMangerClient.getAvailableDialogs() store error ${err}`;
            console.error(error);
            cb?.(null);
            return null;
        }
        for (const dialogName in availableDialogs) {
            const dialog = availableDialogs[dialogName];
            if (dialog.componentType === type) {
                cb?.(dialog);
                return dialog;
            }
        }
        cb?.(null);
        return null;
    }
    async moveDialogFromOpenedToAvailable(identifier) {
        if (!this.DialogStore) {
            const error = "DialogMangerClient.moveDialogFromOpenedToAvailable() store not yet initialized}";
            console.error(error);
            return error;
        }
        const { err, data: dialogs } = await this.DialogStore.getGlobalValue("dialogs");
        if (err || !dialogs) {
            const error = "DialogManagerClient.moveDialogFromOpenedToAvailable() no \"dialogs\" object returned from store";
            console.error(error);
            return error;
        }
        const openedDialogs = dialogs.opened;
        const availableDialogs = dialogs.available;
        delete openedDialogs[identifier.windowName];
        availableDialogs[identifier.windowName] = identifier;
        await this.DialogStore?.set(["dialogs", "opened"], openedDialogs);
        await this.DialogStore?.set(["dialogs", "available"], availableDialogs);
        return null;
    }
    async moveDialogFromAvailableToOpened(identifier) {
        if (!this.DialogStore) {
            const error = "DialogMangerClient.moveDialogFromAvailableToOpened() store not yet initialized}";
            console.error(error);
            return error;
        }
        const { err, data: dialogs } = await this.DialogStore.getGlobalValue("dialogs");
        if (err || !dialogs) {
            const error = "DialogManagerClient.moveDialogFromAvailableToOpened no \"dialogs\" object returned from store";
            console.error(error);
            return error;
        }
        const availableDialogs = dialogs.available;
        const openedDialogs = dialogs.opened;
        delete availableDialogs[identifier.windowName];
        openedDialogs[identifier.windowName] = identifier;
        await this.DialogStore?.set(["dialogs", "available"], availableDialogs);
        await this.DialogStore?.set(["dialogs", "opened"], openedDialogs);
        return null;
    }
}
